import { Component, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Library } from "src/app/models/library";
import { Reader } from "src/app/models/reader";
import { ApplicationPool } from "src/app/services/application.pool";
import { EmptyPageService } from "src/app/services/empty-page.service";

@Component({
  selector: "app-print-reader-id",
  templateUrl: "./print-reader-id.component.html",
  styleUrls: ["./print-reader-id.component.scss"],
})
export class PrintReaderIdComponent {
  @ViewChild("content") contentRef: ElementRef;

  private ids: number[] = [];
  private print: boolean = true;
  private href: string | null = null;

  public blankBarcodes: number[] = [];

  public get Library(): Library {
    return this.dataPool.Library;
  }

  public get Width(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.width}cm`;
    }
  }
  public get Height(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.height}cm`;
    }
  }
  public get MarginLeft(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginLeft}cm`;
    }
  }
  public get MarginTop(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginTop}cm`;
    }
  }

  public get Readers(): Reader[] {
    if (this.dataPool.Readers) {
      const readers = this.dataPool.Readers.filter(
        (m) => this.ids.filter((id) => m.id == id).length > 0
      );
      if (this.print) {
        this.print = false;
        const t = this;
        setTimeout(() => {
          this.emptyPageService.render(
            `<html moznomarginboxes mozdisallowselectionprint><head><style>
            @font-face {
              font-family: "Titillium Web";
              src: url("https://school.schulio.at/assets/fonts/TitilliumWeb-Regular.ttf") format("truetype");
              font-weight: 400;
              font-style: normal;
            }
            @font-face {
              font-family: "Titillium Web";
              src: url("https://school.schulio.at/assets/fonts/TitilliumWeb-SemiBold.ttf") format("truetype");
              font-weight: 500;
              font-style: normal;
            }
            * {
              box-sizing: border-box;
              padding:0;
              margin:0;
              max-width:100%;
              max-height:100%;
              font-family:"Titillium Web",Arial,sans-serif;
              font-weight:normal;
            }
            .reader-id {
              width: 86mm;
              height: 54mm;
              background: #FFFAF2;
              page-break-inside:avoid;
              padding: 0.5cm 0.6cm;
              float:left;
              margin-right: 0.8cm;
              border-bottom: 1px solid #FFECCC;
            }
            h1 {
              font-size: 1.4rem;
              font-weight:500;
              line-height: 1.0em;
              padding-bottom: .2em;
            }
            h2 {
              font-size: 1rem;
              line-height:1rem;
            }
            
           </style></head><body>${this.contentRef.nativeElement.innerHTML}</body></html>`
          );
          setTimeout(() => {
            this.emptyPageService.print();
          }, 600);
          if (this.href) {
            this.router.navigate([this.href.replace(/\%2F/gi, "/")]);
          } else this.router.navigate(["/reader/barcode"]);
        }, 200);
      }
      return readers;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private dataPool: ApplicationPool,
    private router: Router,
    private emptyPageService: EmptyPageService
  ) {
    this.route.params.subscribe((params: any[]) => {
      this.href = JSON.parse(params["val"]).href;
      this.ids = JSON.parse(JSON.parse(params["val"]).reader);
    });
  }

  ngOnInit(): void {}
}
